import { UserProfile } from "@clerk/react";

export function ProfilePage() {
  return <UserProfile routing="path" path="/profile" />;
}
